<template>
  <div id="app">
    <!-- <VideoPlay ref="VideoPlay" /> -->
    <AppNavbar  :titleData="titleData" :focusItem="focusItem" @onFocus="onFocus"/>
    <app-header :style="{height:clientHeight+'px'}" class="appHeader"></app-header>
    <AppContent />
    <AppFooter />
  </div>
</template>
<script>
// import VideoPlay from "@/components/VideoPlay";
import AppNavbar from "@/components/AppNavbar";
import AppHeader from "@/components/AppHeader";
import AppContent from '@/components/AppContent'
import AppFooter from '@/components/AppFooter'
export default {
  components:{
    // VideoPlay,
    AppNavbar,
    AppHeader,
    AppContent,
    AppFooter,
  },
  data(){
    return{
      titleData:[
        {url:'#',title:'首页'},
        {url:'#Product',title:'鲁商通产品'},
        {url:'#tech',title:'鲁商通科技'},
        {url:'#aboutUs',title:'关于我们'},
        {url:'#appActive',title:'近期动态'},
      ],
      clientWidth: window.innerWidth,
      clientHeight:window.innerHeight,
      focusItem:0
    }
  },
  methods:{
    onFocus(index){
      this.focusItem = index
    }
  }
  
}
</script>
<style scoped>
/* .appHeader {
  overflow-x: hidden;
  overflow-y: hidden;
}
.appHeader::-webkit-scrollbar {
    display: none;
} */

</style>